/**
 * Legacy public URL redirects for the web SPA (localhost:8081 dev).
 * Keep in sync with backend/config/publicRedirects.json.
 */
import redirects from '@/constants/publicRedirects.json';

function normalizePath(pathname) {
  const raw = String(pathname || '').split('?')[0].split('#')[0] || '/';
  if (raw === '/') return '/';
  return raw.replace(/\/+$/, '') || '/';
}

const REDIRECT_LOOKUP = new Map(
  Object.entries(redirects).map(([from, to]) => [normalizePath(from).toLowerCase(), to]),
);

/** Returns redirect target for `pathname`, or null if none. Case-insensitive. */
export function getPublicRedirectTarget(pathname) {
  return REDIRECT_LOOKUP.get(normalizePath(pathname).toLowerCase()) || null;
}
